<template>
  <div v-loading.fullscreen="loading">
    <div class="header">
      <el-input
        v-model="search"
        style="width: 250px; margin-right: 10px"
        placeholder="Izlash"
        clearable
        @clear="onSearch"
      >
        <template #append>
          <el-button style="display: flex" @click="onSearch"
            ><img src="@/assets/images/icons/search.svg" alt="" />
          </el-button>
        </template>
      </el-input>
      <el-button
        class="custom-btn"
        @click="showCreateTemplateModal = true"
        type="primary"
        >Qo'shish</el-button
      >
    </div>
    <el-table :data="answersList" border height="calc(100vh - 210px)">
      <el-table-column type="expand">
        <template #default="scope">
          <div class="desc-item">
            <span class="field-title">Shablon matni:</span>
            <span v-html="scope.row.context"></span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="context" label="Shablon" min-width="250">
        <template #default="scope">
          {{ truncateText(scope.row.context, 80) }}
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="Yaratilgan sana" width="180">
        <template #default="scope">
          {{ $moment(scope.row.created_date).format("LLL") }}
        </template>
      </el-table-column>
      <el-table-column width="200" label="Tahrirlash/O'chirish">
        <template #default="scope">
          <el-button
            size="small"
            @click="onEditAnswer(scope.row.id)"
            type="primary"
            >Tahrirlash</el-button
          >
          <el-button
            size="small"
            @click="onDeleteAnswer(scope.row.id)"
            type="danger"
            >O'chirish</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--    edit answer template-->
    <el-dialog
      v-model="showEditTemplateModal"
      title="Javob shablon tahrirlash"
      @close="closeEditTemplateModal"
      style="max-width: 600px"
      align-center
    >
      <el-form
        ref="editTemplateForm"
        label-position="top"
        :model="editForm"
        style="width: 500px"
        :rules="rules"
        status-icon
        hide-required-asterisk
      >
        <el-form-item label="Javob matni" prop="context">
          <el-input
            v-model="editForm.context"
            type="textarea"
            :rows="5"
            placeholder="Javob matnini kiriting."
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeEditTemplateModal">Bekor qilish</el-button>
          <el-button type="primary" @click="completeEditTemplate($refs)">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>

    <!--    create answer template-->
    <el-dialog
      v-model="showCreateTemplateModal"
      title="Javob shablon yaratish"
      @close="closeCreateTemplateModal"
      style="max-width: 600px"
      align-center
    >
      <el-form
        ref="createTemplateForm"
        label-position="top"
        :model="form"
        style="width: 500px"
        :rules="rules"
        status-icon
        hide-required-asterisk
      >
        <el-form-item label="Javob matni" prop="context">
          <el-input
            v-model="form.context"
            type="textarea"
            :rows="5"
            placeholder="Javob matnini kiriting."
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="closeCreateTemplateModal">Bekor qilish</el-button>
          <el-button type="primary" @click="completeCreateTemplate($refs)">
            Saqlash
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, ref } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import http from "@/http";

const loading = ref(false);
const showCreateTemplateModal = ref(false);
const showEditTemplateModal = ref(false);

const form = ref({ context: null });
const editForm = ref({ context: null, id: null });

const answersList = ref([]);
const search = ref(null);

const rules = ref({
  context: [{ required: true, message: "Majburiy maydon", trigger: "change" }],
});

onMounted(() => {
  getAnswerTemplates();
});

const completeCreateTemplate = ($refs) => {
  $refs.createTemplateForm.validate((valid) => {
    if (valid) {
      http
        .post(`api/v1/answer-template`, form.value)
        .then(() => {
          ElMessage.success("Muvofaqqiyatli yaratildi!");
          showCreateTemplateModal.value = false;
          getAnswerTemplates();
        })
        .catch((err) => {
          ElMessage.error("Hatolik qayta urinib ko'ring!");
          console.log(err);
        })
        .finally(() => {
          loading.value = false;
        });
    }
  });
};

const completeEditTemplate = ($refs) => {
  $refs.editTemplateForm.validate((valid) => {
    if (valid) {
      http
        .put(`api/v1/answer-template/${editForm.value.id}`, editForm.value)
        .then(() => {
          ElMessage.success("Muvofaqqiyatli tahrirlandi!");
          showEditTemplateModal.value = false;
          getAnswerTemplates();
        })
        .catch((err) => {
          ElMessage.error("Hatolik qayta urinib ko'ring!");
          console.log(err);
        })
        .finally(() => {
          loading.value = false;
        });
    }
  });
};

const getAnswerTemplates = () => {
  loading.value = true;
  http
    .get(`api/v1/answer-template`, {
      params: {
        search: search.value,
      },
    })
    .then(({ data }) => {
      answersList.value = data.result;
    })
    .catch((err) => {
      ElMessage.error("Hatolik qayta urinib ko'ring!");
      console.log(err);
    })
    .finally(() => {
      loading.value = false;
    });
};

const onSearch = () => {
  getAnswerTemplates();
};

const closeCreateTemplateModal = () => {
  showCreateTemplateModal.value = false;
  form.value.context = null;
};

const closeEditTemplateModal = () => {
  showEditTemplateModal.value = false;
  editForm.value = {};
};

const truncateText = (text, maxLength) => {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

const onEditAnswer = (id) => {
  const selectedForm = answersList.value.find((form) => form.id == id);
  if (selectedForm) {
    editForm.value = { ...selectedForm };
    showEditTemplateModal.value = true;
  }
};

const onDeleteAnswer = (id) => {
  ElMessageBox.confirm("Ushbu shablonni chindan ham ochirasizmi ??", "Diqqat", {
    confirmButtonText: "Ha",
    cancelButtonText: "Bekor qilish",
    type: "warning",
  })
    .then(() => {
      loading.value = true;
      http
        .delete(`api/v1/answer-template/${id}`)
        .then(() => {
          ElMessage.success("Muvofaqqiyatli ochirildi!");
          getAnswerTemplates();
        })
        .catch((err) => {
          ElMessage.error("Hatolik qayta urinib ko'ring!");
          console.log(err);
        })
        .finally(() => {
          loading.value = false;
        });
    })
    .catch((err) => {
      ElMessage.warning("Bekor qilindi!");
    });
};
</script>

<style scoped>
.header {
  display: flex;
  margin-bottom: 10px;
  gap: 10px;
  justify-content: flex-end;
}

.desc-item {
  padding: 20px;
}

.field-title {
  color: #0f152d;
  font-weight: bold;
  margin-right: 15px;
}
</style>
